import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function InvoiceIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 490 490"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          {' '}
          <g>
            {' '}
            <g id="XMLID_25_">
              {' '}
              <g>
                {' '}
                <polygon
                  style={{ fill: '#AFB6BB' }}
                  points="430,100 340,100 340,10 "
                ></polygon>{' '}
                <path
                  style={{ fill: '#FFFFFF' }}
                  d="M430,100v380H60V10h280v90H430z M380,435V165H110v270H380z"
                ></path>{' '}
              </g>{' '}
              <g>
                {' '}
                <path
                  style={{ fill: '#231F20' }}
                  d="M439.976,100c-0.001-2.602-0.993-5.159-2.905-7.071l-90-90c-1.913-1.912-4.47-2.904-7.071-2.905V0 H60c-5.523,0-10,4.477-10,10v470c0,5.523,4.477,10,10,10h370c5.523,0,10-4.477,10-10V100H439.976z M350,34.142L405.858,90H350 V34.142z M70,470V20h260v80c0,5.523,4.477,10,10,10h80v360H70z"
                ></path>{' '}
                <path
                  style={{ fill: '#231F20' }}
                  d="M380,155H110c-5.523,0-10,4.477-10,10v270c0,5.523,4.477,10,10,10h270c5.523,0,10-4.477,10-10V165 C390,159.477,385.523,155,380,155z M370,210H185v-35h185V210z M185,230h50v140h-50V230z M255,230h50v140h-50V230z M325,230h45 v140h-45V230z M165,175v35h-45v-35H165z M120,230h45v195h-45V230z M185,425v-35h185v35H185z"
                ></path>{' '}
                <rect x="100" y="40" style={{ fill: '#231F20' }} width="60" height="20"></rect>{' '}
                <rect x="100" y="75" style={{ fill: '#231F20' }} width="110" height="20"></rect>{' '}
                <rect x="100" y="110" style={{ fill: '#231F20' }} width="30" height="20"></rect>{' '}
                <rect x="140" y="110" style={{ fill: '#231F20' }} width="30" height="20"></rect>{' '}
              </g>{' '}
            </g>{' '}
          </g>{' '}
        </g>
      </svg>
    </SvgIcon>
  );
}
